// extracted by mini-css-extract-plugin
export var avatarContainer = "_4z-1";
export var largeAvatarContainer = "_4z-2";
export var smallAvatarContainer = "_4z-0";